"use strict";
/*
 * Created on 11 02 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AbstractEntityFilter_1 = require("../../core/model/overview/AbstractEntityFilter");
/**
 * {@link ProductInfoFilter product info filter}.
 *
 * @author Radek Beran
 */


var ProductInfoFilter =
/*#__PURE__*/
function (_AbstractEntityFilter) {
  _inherits(ProductInfoFilter, _AbstractEntityFilter);

  function ProductInfoFilter(textForSearch, categoryId) {
    var _this;

    _classCallCheck(this, ProductInfoFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductInfoFilter).call(this));
    _this.textForSearch = textForSearch;
    _this.categoryId = categoryId;
    return _this;
  }

  return ProductInfoFilter;
}(AbstractEntityFilter_1.AbstractEntityFilter);

exports.ProductInfoFilter = ProductInfoFilter;
ProductInfoFilter.EMPTY = new ProductInfoFilter();